import { FC } from 'react'
import { SampleDetailed } from '../types'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { useTranslation } from 'react-i18next'
import { SharedModalContent, SharedModalInputs } from 'views/components/SharedModal'
import { FormGroup, TextArea } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { refetchFunc } from 'modules/domain/common/hooks'

type Props = {
  onClose: () => void
  refetch: refetchFunc
  sample: SampleDetailed
}
export const SamplePauseModal: FC<Props> = ({ onClose, refetch, sample }) => {
  const { t } = useTranslation(['samples'])
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<{ pause_reason: string }>({
    initialValues: {
      pause_reason: '',
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.put(endpoints.sampleRequestPause(sample.sample_request_id.toString()), {
          pause_reason: formik.values.pause_reason,
        })
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })
  return (
    <ResponsiveModal
      id="pauseSampleModal"
      title={t('pauseSample')}
      progress={formProgress}
      onConfirm={formik.submitForm}
      onClose={onClose}
      size="small"
    >
      <SharedModalContent>
        <SharedModalInputs>
          <FormGroup horizontal={false} label={t('pause_reason')} error={formik.errors.pause_reason}>
            <TextArea {...formik.getFieldProps('pause_reason')} height={82} />
          </FormGroup>
        </SharedModalInputs>
      </SharedModalContent>
    </ResponsiveModal>
  )
}
